var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('p',{staticClass:"text"},[_vm._v("\n    Внимание! Проводятся технические работы."),_c('br'),_vm._v("\n    Сервис будет доступен в ближайшее время.\n  ")])])
}]

export { render, staticRenderFns }